import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgIf, NgForOf, NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { filter, Subscription } from 'rxjs';

type MenuItem = {
    title: string;
    link: string;
    image?: string;
    showInPanel: boolean;
};

@Component({
    selector: 'app-header',
    imports: [RouterLink, RouterLinkActive, NgIf, NgForOf, NgClass, ButtonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.less',
    standalone: true,
})
export class HeaderComponent {
    menuItems: MenuItem[] = [
        { title: 'Logo', link: '/main/home', image: '../../../assets/images/logo.svg', showInPanel: false },
        { title: 'Cost Plan', link: '/main/cost-plan', showInPanel: true },
        { title: 'About Us', link: '/main/about-us', showInPanel: true },
    ];
    isPanelOpen = false;
    menuItemsForPanel: MenuItem[] = [];
    routerEventSubscription: Subscription;
    showContactUsButton = true;
    HIDE_CONTACT_US_BUTTON_ROUTES: string[] = ['/main/contact-us'];

    constructor(private router: Router) {
        this.routerEventSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
            next: (event: NavigationEnd) => {
                const currentRoute = event.urlAfterRedirects;
                this.showContactUsButton = !this.HIDE_CONTACT_US_BUTTON_ROUTES.some((route: string) => currentRoute.includes(route));
            },
        });
    }

    ngOnInit() {
        this.menuItemsForPanel = this.menuItems.filter((item) => item.showInPanel);
    }

    togglePanel() {
        this.isPanelOpen = !this.isPanelOpen;
    }

    ngOnDestroy(): void {
        this.routerEventSubscription.unsubscribe();
    }
}
